export default "__VITE_ASSET__BKKRlV$R__"